import React from 'react';

const ImageComponent = ({ src, alt, className, style = {} }) => {
  // 应用5%黑色蒙版效果
  const imageStyle = {
    ...style,
    filter: 'brightness(0.95)'
  };

  return (
    <img 
      src={src} 
      alt={alt} 
      className={className}
      style={imageStyle}
      onError={(e) => {
        e.target.style.backgroundColor = '#F8F9FA';
        e.target.style.display = 'flex';
        e.target.style.alignItems = 'center';
        e.target.style.justifyContent = 'center';
        e.target.style.color = '#555555';
        e.target.innerText = '图片加载中...';
      }}
    />
  );
};

export default ImageComponent;